module.exports = "/assets/img/author-feature-1.e14a2ca6.jpg";